export default __webpack_public_path__ + "static/media/facebook.09ce2980607072276cc5d0521eaec15e.svg";